import { render } from "./trainers-modal.vue?vue&type=template&id=3827f052"
import script from "./trainers-modal.vue?vue&type=script&lang=js"
export * from "./trainers-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__